export const white = "#FFFFFF";
export const pink = "#FDE1D3";
export const babyBlue = "#D9EAF2";
export const gold = "#D69166";
export const gold2 = "#e78344";
export const lightOrange = "#FFF4F3";
export const orange = "#FBC6A8";
export const darkGreen = "#4d4e39";
export const errorRed = "#ff3030";

export const purple = "#5164aa";
export const purple2 = "#805680";
export const purple3 = "#CCB6CC";
export const purple4 = "#F1EBF1";
export const purple5 = "#521A67";

export const black = "#000";
export const black2 = "#313131";
export const black3 = "#252e32";
export const black4 = "#2e2c2c";
export const black5 = "#331535";
export const black6 = "#102121";
export const black7 = "#3f3f3f";
export const black8 = "#191911";
export const transparentBlack = "rgba(0, 0, 0, 0.5)";

export const lightTeal = "#C2E5E6";
export const lightTealHighlight = "#E4F9FA";
export const lightTeal2 = "#C2E1E1";
export const lightTeal3 = "#E9F5F5";
export const lightTeal4 = "#e2eeee";
export const teal = "#086e70";
export const teal2 = "#A8D5D7";
export const teal3 = "#078082";
export const teal4 = "#00A499"
export const tealHighlight = "#B5DDDE";
export const darkTeal = "#485b5b";
export const darkTeal2 = "#8ba0ab";
export const transparentTeal = "rgba(168, 213, 215, 0.54)";

export const gray = "#7C8F90";
export const gray2 = "#979797";
export const gray3 = "#f2f2f2";
export const gray4 = "#efefef";
export const gray5 = "#9b9b9b";
export const gray6 = "#d8d8d8";
export const gray7 = "#4d4d4d";

export const transparent = "transparent";

export const lightOrange2 = "#FF6C6C";
export const lightPurple = "#935FC1";
export const lightGreen = "#72B1A3";

export const opaqueLightOrange2 = "rgba(255, 107, 107, 0.19)";
export const opaqueLightPurple = "rgba(147, 95, 193, 0.19)";
export const opaqueLightGreen = "rgba(114, 177, 163, 0.10)";



// WEBPACK FOOTER //
// ./src/constants/colors.js